<div class="page">
	<!-- <form [formGroup]="from" (ngSubmit)="save()"> -->
	<div class="flex flex-col gap-4">
		<!-- <h4 class="text-lg">Verify Below Transaction ID.</h4> -->
		<p class="font-medium text-red-500">
			Make sure to Double check the <b>Transaction Id</b> & <b>Order Number</b>.
			This can not be undone. User will be notified immediately once this form submitted.
		</p>

		<code class="w-full p-1 font-mono tracking-wide text-center rounded-md bg-zinc-800 text-lime-200">
		{{userTransactionID}}
		</code>

		<!-- <app-field-with-label title="Transaction Id" [required]="true">
				<input type="text" pInputText formControlName="transactionId" [required]="true" />
				<span *ngIf="transactionId.invalid && (transactionId.dirty || transactionId?.touched)">
					<span *ngIf="transactionId?.errors?.['required']"> Transaction Id is required </span>
				</span>
			</app-field-with-label> -->

		<div class="flex justify-end">
			<button pButton type="button" (click)="save()">Submit</button>
		</div>
	</div>
	<!-- </form> -->
</div>